module.exports = __webpack_public_path__ + "img/environment_indoor9.482cd8f4.jpg";